import React, {   useState } from 'react';
import { useForm } from 'react-hook-form';
import {  NavLink, useNavigate } from 'react-router-dom';
import { useLoginMutation, useSignupMutation } from '../../apis/UsersApi';
import { jwtDecode } from 'jwt-decode';

const Register = ({ toggleView }) => {
    const [isSeller, setIsSeller] = useState(false);
    const [createRegister, { isLoading, error }] = useSignupMutation();
    const navigate=useNavigate();
    const [login, { isLoading:isLoadingLogin, error:errorLogin }] = useLoginMutation();
    const [showPassword, setShowPassword] = useState(false);

     const [fieldErrors, setFieldErrors] = useState({
        username: '',
        email: '',
        phoneNumber: ''
    });
    const { register, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            username: "",
            email: "",
            nomPrenom: "",
            password: "",
            role: [""], // Default role
            invitationCode: "",
            firstName: "",
            lastName: "",
            shopName: "",
            phoneNumber: "",
        },
    });
    
    // Watch the role value to make sure it's updated
    const role = watch("role");
    
    // Update role based on seller checkbox
    const handleSellerToggle = (e) => {
        setIsSeller(e.target.checked); // Update the local seller state
        const updatedRole = e.target.checked ? ["vender"] : ["customer"];
        setValue("role", updatedRole); // Update role in the form state
    };
  

  const onSubmit = async (data) => {
  try {
    // 1) Clear out any old error messages
    setFieldErrors({ username: "", email: "", phoneNumber: "" });

    // 2) If role is "customer", wipe out vendor fields
    const cleanedData = role.includes("customer")
      ? {
          ...data,
          role,
          invitationCode: "",
          firstName: "",
          lastName: "",
          shopName: "",
        }
      : data;

    // 3) Call the signup endpoint
    await createRegister(cleanedData).unwrap();

    // 4) If successful, immediately log in
    await LoginAfterRegister(cleanedData.email, cleanedData.password);
    alert("Registration successful!");
  } catch (err) {
    // ⬇️ THIS is the only block we change ⬇️
    console.log("Full error object:", err);

    // If this is an AxiosError, it will have `response`
    if (err.response && err.response.data) {
      /**
       * The Spring controller currently returns a MessageResponse
       * whose `body` is a plain string (e.g. "UserName Exist").
       *
       * Depending on how you serialized it, you might need to do:
       *    const serverMsg = err.response.data.message || err.response.data;
       * 
       * In my example, I’ll assume `err.response.data` is exactly the string.
       **/
      const serverMsg = typeof err.response.data === "string"
        ? err.response.data
        : err.response.data.message || JSON.stringify(err.response.data);

      // Map that string to a single field error:
      if (serverMsg.includes("UserName Exist")) {
        setFieldErrors((prev) => ({
          ...prev,
          username: "Ce nom d’utilisateur est déjà utilisé.",
        }));
      } else if (serverMsg.includes("Email Exist")) {
        setFieldErrors((prev) => ({
          ...prev,
          email: "Cet email est déjà utilisé.",
        }));
      } else if (serverMsg.includes("Phone Number Exist")) {
        setFieldErrors((prev) => ({
          ...prev,
          phoneNumber: "Ce numéro de téléphone est déjà utilisé.",
        }));
      } else {
        // Fallback: show a generic alert if it’s something else
        alert(serverMsg);
      }
    } else {
      // If `err.response` is not defined, it wasn’t a 400 from backend,
      // so just show a generic message:
      alert("Registration failed. Please try again.");
    }
  }
};

    const LoginAfterRegister = async (email,password) => {
     
        try {
            // Call the login API
            const response = await login({ email, password }).unwrap();
    
            // Extract tokens and user data from response
            const { accessToken, refreshToken, userData } = response;
    
            // Decode and validate the access token
            const decodedToken = jwtDecode(accessToken);
            if (!decodedToken || decodedToken.exp < Date.now() / 1000) {
                throw new Error("Invalid or expired token");
            }
    
            // Store tokens in localStorage
            localStorage.setItem("jwt", accessToken);
            localStorage.setItem("refreshToken", refreshToken);
    
            // Optionally store user data
            localStorage.setItem("userData", JSON.stringify(userData));
    
            // Log user data for debugging
         //   console.log("User logged in:", userData);
    
            // Navigate to the redirect URL or a default route
            const redirectUrl = "/";
            navigate(redirectUrl);
        } catch (err) {
            // Handle error if login fails
       //     console.error("Login failed:", err.message);
        }
    }
    return (
        <div className="col-xl-6">
            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
                {/* Add the logo image here */}
                <div className="mb-16 flex-center">
                <img 
        src={`${process.env.PUBLIC_URL}/assets/images/logo/logoOld.png`} 
        alt="Logo" 
        className="img-fluid" 
        style={{ width: '100px', height: 'auto' }} // Adjust width as needed
    />
            </div>                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* General Registration Fields */}
                    <div className="mb-24">
                        <label
                            htmlFor="usernameTwo"
                            className="text-neutral-900 text-lg mb-8 fw-medium"
                        >
                            Username <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className={`common-input ${fieldErrors.username ? 'is-invalid' : ''}`}
                             id="usernameTwo"
                            placeholder="Write a username"
                            {...register("username", { required: true })}
                        />
                         {fieldErrors.username && (
                    <div className="text-danger mt-2">{fieldErrors.username}</div>
                )}
                    </div>
                    <div className="mb-24">
                                <label
                                    htmlFor="telephone"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    Telephone <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="tel"
                                    className={`common-input ${fieldErrors.phoneNumber ? 'is-invalid' : ''}`}
                                    id="telephone"
                                    placeholder="Enter Telephone Number"
                                    {...register("phoneNumber", { required: true })}
                                />
                                 {fieldErrors.phoneNumber && (
                    <div className="text-danger mt-2">{fieldErrors.phoneNumber}</div>
                )}
                            </div>
                    <div className="mb-24">
                        <label
                            htmlFor="emailTwo"
                            className="text-neutral-900 text-lg mb-8 fw-medium"
                        >
                            Email address <span className="text-danger">*</span>
                        </label>
                        <input
                            type="email"
                            className={`common-input ${fieldErrors.email ? 'is-invalid' : ''}`}
                            id="emailTwo"
                            placeholder="Enter Email Address"
                            {...register("email", { required: true })}
                        />
                         {fieldErrors.email && (
                    <div className="text-danger mt-2">{fieldErrors.email}</div>
                )}
                    </div>
                    <div className="mb-24">
    <label
        htmlFor="enter-password"
        className="text-neutral-900 text-lg mb-8 fw-medium"
    >
        Password <span className="text-danger">*</span>
    </label>
    <div className="position-relative">
        <input
            type={showPassword ? "text" : "password"}
            className="common-input"
            id="enter-password"
            placeholder="Enter Password"
            {...register("password", { required: true })}
        />
        <span
            className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${
                showPassword ? 'ph-eye' : 'ph-eye-slash'
            }`}
            onClick={() => setShowPassword(!showPassword)}
        />
    </div>
</div>

                    {/* Toggle for Becoming a Seller */}
                    <div className="form-check mb-24">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="becomeSeller"
                            onChange={handleSellerToggle}
                        />
                        <label
                            className="form-check-label text-neutral-900 text-lg fw-medium"
                            htmlFor="becomeSeller"
                        >
                            I want to become a seller
                        </label>
                    </div>

                    {/* Seller-Specific Fields */}
                    {isSeller && (
                        <div>
                            <div className="mb-24">
                                <label
                                    htmlFor="invitationCode"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    Invitation Code <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="common-input"
                                    id="invitationCode"
                                    placeholder="Enter Invitation Code"
                                    {...register("invitationCode", { required: true })}
                                />
                            </div>
                            <div className="mb-24">
                                <label
                                    htmlFor="firstName"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    First Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="common-input"
                                    id="firstName"
                                    placeholder="Enter First Name"
                                    {...register("firstName", { required: true })}
                                />
                            </div>
                            <div className="mb-24">
                                <label
                                    htmlFor="lastName"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    Last Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="common-input"
                                    id="lastName"
                                    placeholder="Enter Last Name"
                                    {...register("lastName", { required: true })}
                                />
                            </div>
                            <div className="mb-24">
                                <label
                                    htmlFor="shopName"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    Shop Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="common-input"
                                    id="shopName"
                                    placeholder="Enter Shop Name"
                                    {...register("shopName", { required: true })}
                                />
                            </div>
                            
                        </div>
                    )}

                    <div className="form-check mb-24">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="agreeTerms"
                            required
                        />
                        <label
                            className="form-check-label text-neutral-700 text-lg fw-medium"
                            htmlFor="agreeTerms"
                        >
                            I have read and agree to the{' '}
                            <NavLink to="/term-conditions" className="text-main-600 text-decoration-underline">
                                Terms & Conditions
                            </NavLink>
                            .
                        </label>
                    </div>

                    {/* Submit Button */}
                    <div className="mt-48">
                      
                    <button 
                        type="submit" 
                        className="btn btn-main py-18 px-40" 
                        disabled={isLoading || isLoadingLogin}
                        >
                        {isLoading 
                            ? "Creating Account..." 
                            : isLoadingLogin 
                            ? "Logging in..." 
                            : "Register"}
                    </button>

                        {error && <p className="text-danger mt-2">Registration failed. Please try again.</p>}
                        {error && <p className="text-danger mt-2">Login failed. Please try again.</p>}

                        <div className="mt-24">
                            <p className="text-sm">
                                Already have an account?{' '}
                                <button
                                    type="button"
                                    onClick={toggleView}
                                    className="text-main-600 text-decoration-underline bg-transparent border-0 cursor-pointer"
                                >
                                    Login here
                                </button>
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Register;
